export default __webpack_public_path__ + "static/media/reports-off.816c224e.svg";